import { render, staticRenderFns } from "./PlanoCuidadoIcon.vue?vue&type=template&id=17e3791d"
import script from "./PlanoCuidadoIcon.vue?vue&type=script&lang=js"
export * from "./PlanoCuidadoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports